import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import { Button, CircularProgress, Paper, Typography } from '@material-ui/core';
import 'toastr/build/toastr.min.css';
import { DisplayMessage } from '../../../services/helpers.js';
import { Dialog, AppBar, Toolbar, Slide } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { Redirect } from 'react-router-dom';
import appFetch from '../../../api/appFetch.js';
import { WorkPreparationMoboOutletsRolesUrl } from '../../../constants/apiUrls.js';
import RolesDropdown from '../../Common/Dropdowns/RolesDropdown.js';
import OutletsDropdown from '../../Common/Dropdowns/OutletsDropdown.js';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default class WorkPreparationsNew extends Component {

    constructor(props) {
        super(props);

        var moboOutletId = 0;
        if (this.props != undefined) {
            moboOutletId = this.props.moboOutletId;
        }

        this.state = {
            roles: [],
            moboOutletId: moboOutletId,
            roleId: 0,

            open: true,
            loading: false,
            requestInProgress: false,
            redirect: null,
            moboOutletRoleWasCreated: false,
        };
    }

    isValidForm = () => {
        const { moboOutletId, roleId } = this.state

        if (!moboOutletId) {
            return false;
        }

        if (!roleId) {
            return false;
        }

        return true;
    }

    handleSubmit = () => {
        this.saveMoboOutletRole();
    }

    saveMoboOutletRole = () => {
        let resources = this.props.resources;

        this.setState({ requestInProgress: true });

        var json = JSON.stringify({
            roleId: this.state.roleId,
            moboOutletId: this.state.moboOutletId
        });

        const url = WorkPreparationMoboOutletsRolesUrl();

        appFetch({
            url: url,
            method: 'POST',
            body: json,
            onSuccess: (data, response) => {
                DisplayMessage(resources["NewRoleWasSaved"], "success");
                this.setState({ requestInProgress: false, redirect: "/workpreparations", moboOutletRoleWasCreated: response.ok });
            },
            onError: (data) => {
                for (var i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    validateData(moboOutletId, roleId) {
        return moboOutletId > 0 && roleId > 0;
    }


    handleChangeOutlet = e => {
        this.setState({ moboOutletId: parseInt(e.target.value) });
    };

    handleChangeRole = e => {
        this.setState({ roleId: parseInt(e.target.value) });
    };

    handleClose = () => {
        this.setState({ open: false, redirect: "/workpreparations" });
    }

    renderForm() {
        const { redirect, requestInProgress, moboOutletId, roleId, open } = this.state;
        const { resources } = this.props;

        if (redirect) {
            return <Redirect to={{ pathname: this.state.redirect, state: { moboOutletId: moboOutletId } }} />
        }

        const handleSubmit = (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.handleSubmit();
        };

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect;

        return (
            <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
                <Form onSubmit={handleSubmit} >

                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton edge="start" id="close-add-workpreparation-role" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {resources["AddNewRoleTitle"]}
                            </Typography>
                            <Button id="workpreparation-role-save" color="inherit" type="submit" disabled={isSaveButtonDisabled}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>

                    <div className="container">
                        <div className="py-4 grey">
                            <Paper elevation={3} className="p-4 mt-3 mb-3">
                                <Form.Group className="pt-3" style={{ display: "flex" }}>
                                    <div className="col-md-3"></div>
                                    <OutletsDropdown
                                        resources={resources}
                                        outlets={this.props.accessibleMoboOutlets}
                                        outlet={moboOutletId}
                                        onOutletChange={this.handleChangeOutlet}
                                        containerClass="col-6 helper-text-red"
                                        noPlaceholder
                                    />
                                </Form.Group>
                                <Form.Group style={{ display: "flex" }}>
                                    <div className="col-md-3"></div>
                                    <RolesDropdown
                                        resources={resources}
                                        role={roleId}
                                        onRoleChange={this.handleChangeRole}
                                        onRequestStart={() => this.setState({ requestInProgress: true })}
                                        onRequestEnd={() => this.setState({ requestInProgress: false })}
                                        containerClass="col-md-6"
                                        helperText={resources["IsMandatory"]}
                                        required
                                    />
                                </Form.Group>
                            </Paper>
                        </div>
                    </div>
                </Form>
            </Dialog >
        );
    }

    render() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>)
        }

        return (
            <div className={"pt-4 grey text-center" + (this.state.loading ? 'fadeOut' : 'fadeIn')} >
                <div className="container">
                    {this.renderForm()}
                </div>
            </div>
        );
    }
}